import {takeLatest, put,select} from 'redux-saga/effects';
import {actions as listActions} from '../slices/CardTypeListSlice';
import {actions} from '../slices/CardTypeSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';
import {actions as listMTPriceActions} from '../slices/MonthlyTicketPriceListSlice';
import {actions as MTPriceActions} from '../slices/MonthlyTicketPriceSlice';
import {actions as listMTMultipleActions} from '../slices/MonthlyTicketMultipleListSlice';
import {actions as MTMultipleActions} from '../slices/MonthlyTicketMultipleSlice';


const getSearchCriteria = state => state.monthlyTicketCardTypeList.searchCriteria;
const getMTPriceSearchCriteria = state => state.monthlyTicketPriceList.searchCriteria;
const getMTMultipleSearchCriteria = state => state.monthlyTicketMultipleList.searchCriteria;
function* getCardTypeList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_cards')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
                
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}

function* getMTPriceList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(
            `${config.getUrl('bus_route_subscription')}/routes/${filters.routeId}`, {
                params: {
                    page: page ? page - 1 : null,
                    size: limit,
                    ...filters,
                    routeId:undefined
                }
            });
        yield put({type: listMTPriceActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listMTPriceActions.get_list_failed.type, payload: error});
    }
}

function* getMTMultipleList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(
            `${config.getUrl('bus_route_subscription')}/routes/multiple`, {
                params: {
                    page: page ? page - 1 : null,
                    size: limit,
                    ...filters,
                    routeId:undefined
                }
            });
        yield put({type: listMTMultipleActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listMTMultipleActions.get_list_failed.type, payload: error});
    }
}


function* createCardType({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_cards')}`, {
            ...params
        });
        yield put({type: actions.create_card_type_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_card_type_failed.type, payload: error});
    }
}

function* updateCardType({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_cards')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.update_card_type_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.update_card_type_failed.type, payload: error});
    }
}

// function* deleteCardType({payload:{id}}) {
//     try {
//         const response = yield NetworkHandler.delete(`${config.getUrl('card_type_api')}/${id}`);
//         yield put({type: actions.delete_card_type_succeed.type, payload: {...response}});
//         NotificationHandler.notifySuccess('Xoá thành công!');
//         const searchCriteria = yield select(getSearchCriteria);
//         yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
//     } catch (error) {
//         NotificationHandler.notifyError(error.message);
//         yield put({type: actions.delete_card_type_failed.type, payload: error});
//     }
// }

function* createMTPrice({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route_subscription')}`, {
            ...params
        });
        yield put({type: MTPriceActions.create_monthly_ticket_price_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getMTPriceSearchCriteria);
        yield put({type: listMTPriceActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: MTPriceActions.create_monthly_ticket_price_failed.type, payload: error});
    }
}

function* updateMTPrice({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route_subscription')}/${params.id}`, {
            ...params
        });
        yield put({type: MTPriceActions.update_monthly_ticket_price_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getMTPriceSearchCriteria);
        yield put({type: listMTPriceActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: MTPriceActions.update_monthly_ticket_price_failed.type, payload: error});
    }
}

function* createMTMultiple({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_route_subscription')}`, {
            ...params
        });
        yield put({type: MTMultipleActions.create_monthly_ticket_multiple_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getMTMultipleSearchCriteria);
        yield put({type: listMTMultipleActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: MTMultipleActions.create_monthly_ticket_multiple_failed.type, payload: error});
    }
}

function* updateMTMultiple({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_route_subscription')}/${params.id}`, {
            ...params
        });
        yield put({type: MTMultipleActions.update_monthly_ticket_multiple_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getMTMultipleSearchCriteria);
        yield put({type: listMTMultipleActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: MTMultipleActions.update_monthly_ticket_multiple_failed.type, payload: error});
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getCardTypeList);
    yield takeLatest(actions.create_card_type.type, createCardType);
    yield takeLatest(actions.update_card_type.type, updateCardType);
    // yield takeLatest(actions.delete_card_type.type, deleteCardType);
    yield takeLatest(listMTPriceActions.get_list.type, getMTPriceList);
    yield takeLatest(MTPriceActions.create_monthly_ticket_price.type, createMTPrice);
    yield takeLatest(MTPriceActions.update_monthly_ticket_price.type, updateMTPrice);
    yield takeLatest(listMTMultipleActions.get_list.type, getMTMultipleList);
    yield takeLatest(MTMultipleActions.create_monthly_ticket_multiple.type, createMTMultiple);
    yield takeLatest(MTMultipleActions.update_monthly_ticket_multiple.type, updateMTMultiple);
}

export default watchRequestDetail;